import * as React from 'react';

import './signature-preview.css';
import { Button } from '@/ui-kit/button/button';
import clsx from 'clsx';

interface SignaturePreviewProps extends React.HTMLAttributes<HTMLDivElement> {
  previewUrl: string;
  onClear?: React.MouseEventHandler<HTMLButtonElement>;
}

const SignaturePreview = React.forwardRef<
  HTMLDivElement,
  SignaturePreviewProps
>(({ previewUrl, onClear, className, ...props }, ref) => {
  const containerClasses = clsx('sp__container', className);

  return (
    <div ref={ref} className={containerClasses} {...props}>
      <img src={previewUrl} alt="Signature" className="sp__image" />
      <Button
        type="button"
        className="sp__button"
        asRemoveIcon="signature"
        onClick={onClear}
      />
    </div>
  );
});

export { SignaturePreview };
